import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';
import Loading from 'components/Loading/Loading';
import { loadScript } from 'utils/loadScript';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { createReservation } from 'actions/reservationActions';
import { setBookingData, updateCongratsStatus } from 'actions/userActions';
import './style.css';

class Success extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasBooking: Boolean(props.bookingData),
      isBooking: true
    };
  }

  componentDidMount() {
    fbq('track', 'Purchase'); // eslint-disable-line

    ReactGA.initialize('UA-49918148-2', {
      gaOptions: {
        userId: this.props.user.id
      }
    });
    ReactGA.pageview(window.location.pathname + window.location.search);

    loadScript('//portal.referralcandy.com/assets/widgets/refcandy-candyjar.js');

    browserHistory.push(`/success?course=${this.props.user.upsellData.paid ? 'purchase' : 'no'}`);
  }

  componentDidUpdate() {
    const { bookingData, user } = this.props;
    // create reservation if user entered onboarding from booking flow
    if (bookingData) {
      const d = bookingData;
      this.props.setBookingData(null);
      setTimeout(() => {
        this.props.createReservation(d, true, () => {
          this.setState({ isBooking: false });
        });
      }, 2000);
    }
  }

  handleClose = () => {
    this.props.updateCongratsStatus('DONE');
  }

  handleReservations = () => {
    this.handleClose();
    browserHistory.push('/reservations');
  }

  render() {
    const { user } = this.props;

    const courseButton = user.upsellData.paid ? (
      <a
        href="https://www.rypeapp.com/exclusive/"
        target="_blank"
        rel="noopener noreferrer"
        className="d-block mx-auto btn btn-primary btn-lg btn-cursor btn-congrats  mt-3 mt-md-4"
      >
        View my course
      </a>
    ) : null;

    let content = null;
    if (!this.state.hasBooking) {
      content = (
        <Fragment>
          <h5 className="congrats-header">Congrats {user.profile.givenName}, you&#39;re all set up!</h5>
          <p className="congrats-sub-header">It&#39;s time to get started.</p>
          <button
            type="button"
            className="d-block mx-auto btn btn-primary btn-lg btn-cursor btn-congrats"
            onClick={this.handleClose}
            data-qa-id="book-first-lesson-button"
          >
            Book my first lesson
          </button>
          {courseButton}
        </Fragment>
      );
    } else if (this.state.isBooking) {
      content = <Loading />;
    } else {
      content = (
        <Fragment>
          <h5 className="congrats-header mb-4 mb-md-5">
            Congrats on booking your first lesson {user.profile.givenName}!
          </h5>
          <button
            type="button"
            className="d-block mx-auto btn btn-primary btn-lg btn-cursor btn-congrats"
            onClick={this.handleReservations}
          >
            See my reservations
          </button>
          {courseButton}
          <button
            type="button"
            className="d-block mx-auto btn btn-secondary btn-lg btn-cursor btn-congrats mt-3 mt-md-4"
            onClick={this.handleClose}
          >
            Book another lesson
          </button>
        </Fragment>
      );
    }

    const customerId = this.props.user.profile.stripeCustomerId;
    const merchantId = "77900";
    const shareASaleUrl = `https://www.shareasale.com/sale.cfm?tracking=${customerId}&amount=0.00&merchantID=${merchantId}&transtype=lead`;

    return (
      <div className="SuccessPage">
        <div className="congrats bg-white text-center">{content}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    bookingData: state.user.bookingData
  };
}

export default connect(
  mapStateToProps,
  {
    createReservation,
    setBookingData,
    updateCongratsStatus
  }
)(Success);



// WEBPACK FOOTER //
// ./src/pages/student/Success/index.js